<template>
  <Comments :comments="comments" @comment:deleted="removeComment">
    <template #default="{ scrollToEnd }">
      <div v-if="createFormVisible" class="sticky bottom-0 bg-white p-4 rounded border">
        <CommentForm :submit-action="submitComment" @submit:resolved="createFormVisible = false">
          <button type="button" class="btn btn-ghost ml-2" @click="createFormVisible = false">
            Cancel
          </button>
        </CommentForm>
      </div>
      <button
        v-else
        type="button"
        class="btn btn-success w-full sticky bottom-0"
        @click="
          () => {
            createFormVisible = true;
            $nextTick(() => {
              scrollToEnd();
            });
          }
        "
      >
        Add Comment
      </button>
    </template>
  </Comments>
</template>

<script>
import Comments from '@/components/Comments/Comments.vue';
import CommentForm from '@/components/Comments/CommentForm.vue';

const STATUS_IDLE = 'STATUS_IDLE';
const STATUS_PENDING = 'STATUS_PENDING';
const STATUS_RESOLVED = 'STATUS_RESOLVED';
const STATUS_REJECTED = 'STATUS_REJECTED';

export default {
  name: 'TaskComments',

  components: {
    Comments,
    CommentForm,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loadStatus: STATUS_IDLE,
      createFormVisible: false,
    };
  },

  computed: {
    comments() {
      return this.$store.getters['ui/taskComments/comments'];
    },
  },

  created() {
    this.loadComments();
  },

  destroyed() {
    this.$store.dispatch({
      type: 'ui/taskComments/reset',
    });
  },

  methods: {
    async loadComments() {
      this.loadStatus = STATUS_PENDING;
      try {
        await this.$store.dispatch({
          type: 'ui/taskComments/load',
          taskId: this.task.uuid,
        });

        this.loadStatus = STATUS_RESOLVED;
      } catch (error) {
        this.loadStatus = STATUS_REJECTED;
      }
    },
    submitComment(body) {
      return this.$store
        .dispatch({
          type: 'ui/taskComments/store',
          taskId: this.task.uuid,
          body,
        })
        .then((response) => {
          this.commentFormVisible = false;
          this.$emit('updated-comments');
          return Promise.resolve(response);
        })
        .catch((error) => Promise.reject(error));
    },
    async removeComment(comment) {
      try {
        await this.$store.dispatch({
          type: 'ui/taskComments/remove',
          commentId: comment.uuid,
          forget: true,
        });

        this.$emit('updated-comments');
      } catch (error) {
        //
      }
    },
  },
};
</script>
